import UpDownValue from '../upDownValue'
import { Button } from 'antd'
import Meta from 'antd/lib/card/Meta'
import { t } from 'i18next'
import {
  StyledCard,
  StyledSpanCount
} from 'pages/main/menuListMan/index.styled'
import { ReactNode } from 'react'
import styled from 'styled-components'

const StyledMeta = styled(Meta)`
  .ant-btn {
    border-radius: 50%;
  }
  .ant-card-meta-description {
    font-size: 2rem !important;
    font-weight: 600;
    color: var(--color-gray-110);
  }
  .ant-card-meta-title {
    font-size: 1.4rem;
    font-weight: 400;
    color: var(--color-gray-105);
  }
  .ant-card-meta {
    display: flex;
    align-items: center;
  }
  .ant-card-meta-detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`
const StyledCardContainer = styled(StyledCard)`
  border-radius: 6px;
  margin-top: 0;
  .ant-card-body {
    display: flex;
    align-items: center;
  }
  &.yellow {
    .ant-btn {
      background: var(--color-amber-105);
      border-color: var(--color-amber-107);
    }
  }
  &.blue {
    .ant-btn {
      background: var(--color-blue-105);
      border-color: var(--color-blue-107);
    }
  }
  &.red {
    .ant-btn {
      background: var(--color-red-105);
      border-color: var(--color-red-107);
    }
  }
  &.green {
    .ant-btn {
      background: var(--color-primary-105);
      border-color: var(--color-primary-107);
    }
  }
  &.orange {
    .ant-btn {
      background: var(--color-orange-105);
      border-color: var(--color-orange-107);
    }
  }
`
interface IProps {
  color?: 'yellow' | 'blue' | 'green' | 'red' | 'orange'
  className?: string
  icon?: ReactNode
  label?: string
  value?: string | number
  badge?: { value: string | number; type: 'up' | 'down' }
}
const CardReport = (props: IProps) => {
  const { color = 'green', className, icon, label, value, badge } = props
  return (
    <>
      <StyledCardContainer loading={false} className={`${className} ${color}`}>
        <StyledMeta
          avatar={
            <Button
              type="primary"
              icon={icon}
              size="large"
              className="button-menu"
            />
          }
          title={t(label || '')}
          description={value}
        />
        <StyledSpanCount className="span-count">
          <UpDownValue {...badge} />
        </StyledSpanCount>
      </StyledCardContainer>
    </>
  )
}

export default CardReport
